import dayjs from "dayjs";

// Shared by the block modal, the daily grid and the delete confirmation so the
// type labels and the form rules live in one place. The backend stays the source
// of truth (helper/reservations/courtBlocks.js): these rules only give feedback
// before the request.

export const MAX_BLOCK_DAYS = 31;
export const DEFAULT_BLOCK_TYPE = "other";

export const BLOCK_TYPE_OPTIONS = [
	{ value: "tournament", label: "Torneo" },
	{ value: "maintenance", label: "Mantenimiento" },
	{ value: "other", label: "Otro" },
];

// Grid card identity. Blocks stored before types existed carry no `type` and
// read as the generic "Bloqueo", same as "other".
const CARD_META = {
	tournament: { label: "Torneo", tone: "tournament" },
	maintenance: { label: "Mantenimiento", tone: "maintenance" },
};

export const blockTypeMeta = (type) =>
	CARD_META[type] || { label: "Bloqueo", tone: "other" };

const shortDate = (isoDate) => {
	const day = dayjs(isoDate);
	return day.isValid() ? day.format("DD/MM") : null;
};

// "17/10 al 19/10" for a block that spans several days; null for a single day
// or a block without a group.
export const blockGroupRange = (block) => {
	const { groupDateFrom, groupDateTo } = block || {};
	if (!groupDateFrom || !groupDateTo || groupDateFrom === groupDateTo) {
		return null;
	}
	const from = shortDate(groupDateFrom);
	const to = shortDate(groupDateTo);
	return from && to ? `${from} al ${to}` : null;
};

// Rows of the block's group (one per court and day); 1 when ungrouped.
export const blockGroupSize = (block) => {
	const size = Number(block?.groupSize);
	return Number.isInteger(size) && size > 1 ? size : 1;
};

const DAY_MS = 24 * 60 * 60 * 1000;

// Inclusive day count between two YYYY-MM-DD strings, computed in UTC so a
// daylight-saving change cannot shift it.
const inclusiveDays = (dateFrom, dateTo) =>
	Math.round(
		(Date.parse(`${dateTo}T00:00:00Z`) - Date.parse(`${dateFrom}T00:00:00Z`)) /
			DAY_MS,
	) + 1;

/**
 * Mirrors the backend rules for a club block: dates in order, at most 31 days,
 * both times or none, start before end. Returns one message per problem area;
 * an empty object means the form can be submitted.
 */
export const validateCourtBlockForm = ({
	dateFrom,
	dateTo,
	allDay,
	slotStart,
	slotEnd,
	courtMode,
	courtIds = [],
}) => {
	const errors = {};

	if (!dateFrom || !dateTo) {
		errors.dates = "Elegí desde y hasta qué día.";
	} else if (dateTo < dateFrom) {
		errors.dates = "La fecha Hasta no puede ser anterior a Desde.";
	} else if (inclusiveDays(dateFrom, dateTo) > MAX_BLOCK_DAYS) {
		errors.dates = `El bloqueo no puede superar los ${MAX_BLOCK_DAYS} días.`;
	}

	if (!allDay) {
		if (!slotStart || !slotEnd) {
			errors.time = "Elegí desde y hasta qué hora, o dejá marcado Todo el día.";
		} else if (slotStart >= slotEnd) {
			errors.time =
				"La hora de fin tiene que ser posterior a la de inicio. Para bloquear de noche a la madrugada, bloqueá el día completo.";
		}
	}

	if (courtMode === "some" && courtIds.length === 0) {
		errors.courts = "Elegí al menos una cancha.";
	}

	return errors;
};
